exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cart-name-cell[data-v-7e3be4d5]{\n  max-width: 250px;\n}\n", ""]);

// exports
